import React, {useEffect, useState} from "react";
import {GrFormClose} from "react-icons/gr";
import {RiArrowDownSLine} from "react-icons/ri";
import {CSSTransition} from "react-transition-group";
import './select.css';
import './scrollbarStyle.css';

const Select = ({...props}) => {

    const {
        flexDimension,
        options,
        parseOptions,
        onChange,
        value,
        active,
        focus,
        openAbove = false,
        openStyle,
        selectClassName = "",
        placeholder = ""
    } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [searchName, setSearchName] = useState("");
    const [selectedItem, setSelectedItem] = useState(value && value);

    const nodeRef = React.useRef(null);

    const handleOpening = () => {
        setIsOpen(!isOpen);
    }

    const handleChange = (evt: any) => {
        setSearchName(evt.target.value);
    }

    const handleSelection = (opt: any) => {
        if (opt) {
            setSelectedItem(opt);
            setIsOpen(false);
            if (onChange) onChange(opt);
        }
    }

    const getFilteredOptions = () => {
        const filtered = options.map((opt: any, index: any) => {
            let _opt = opt;
            if (parseOptions) {
                _opt = parseOptions(opt);
            }
            if (_opt.label && _opt.label.toLowerCase().includes(searchName.toLowerCase()) || searchName === '')
                return <div key={index} onClick={() => handleSelection(opt)}
                            className={"cursor-pointer hover:bg-gray-100"}>{_opt.label}</div>
        })

        return filtered;
    }

    const showSelected = () => {
        if (parseOptions) {
            return parseOptions(selectedItem);
        } else return selectedItem;
    }

    const unselectItem = () => {
        setSelectedItem(null);
        onChange(null);
    }

    const handleFocus = () => {
        focus && focus();
        setIsOpen(false);
    }

    useEffect(() => {
        setSelectedItem(value && value);
    }, [value]);

    return (
        <div className={"flex items-center justify-center z-100"} style={{flex: flexDimension}}>
            {isOpen &&
                <div className={"bg-transparent fixed w-screen h-screen z-10"} onClick={handleFocus}/>
            }
            <div className={"relative w-full pr-1"}>
                <div
                    className={`bg-white overflow-hidden rounded h-8 self-center p-2 flex flex-row justify-between items-center ${selectClassName}`}
                    style={openStyle}>
                    <div className={"border-red-300 border-0 flex flex-row items-center"}>
                        {selectedItem && showSelected().label
                            ? <div className={"flex flex-row items-center"}>
                                <div className={"overflow-x-auto"}
                                     style={{lineHeight: 1.8, fontSize: 12}}>{showSelected().label}</div>
                                <div><GrFormClose size={20} onClick={unselectItem}/></div>
                            </div>
                            :
                            <div className={"text-gray-400"} style={{fontSize: 12}}>{placeholder}</div>
                        }
                    </div>
                    <div onClick={handleOpening} className={"flex flex-row"} style={{minHeight: 20, minWidth: 20}}>
                        <RiArrowDownSLine size={20}/>
                    </div>
                </div>
                <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={300} classNames="select2">
                    <div ref={nodeRef}
                         className={"absolute select2 w-full bg-white rounded-md flex flex-col overflow-hidden z-10"}
                         style={{top: openAbove ? -305 : 35, left: 2}}>
                        <input className={"outline-none border border-gray-200 mb-1 rounded-md"} value={searchName}
                               type={"text"} onChange={handleChange}/>
                        <div
                            className={"overflow-y-scroll darkBgCustomScrollbar"}>{options && getFilteredOptions()}</div>
                    </div>
                </CSSTransition>
            </div>
        </div>
    );
}

export default Select;